import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";
import PoolAuditTable from "./PoolAuditTable";
import { fetchWithToken } from "../../../../apiUtils";

const useStyles = makeStyles({
  table: {
    marginTop: 45,
  },
  loading: {
    marginTop: "25%",
    marginLeft: "50%",
  },
});

const PoolAudit = () => {
  const classes = useStyles();

  const [dataObj, setDataObj] = useState({
    poolAudits: [],
    loading: true,
  });

  useEffect(() => {
    fetchWithToken("api/PoolAudit/")
      .then((response) => response.json())
      .then((data) =>
        setDataObj({
          poolAudits: data,
          loading: false,
        })
      );
  }, []);

  return (
    <>
      {dataObj.loading ? (
        <CircularProgress className={classes.loading} />
      ) : (
        <div className={classes.table}>
          <PoolAuditTable data={dataObj.poolAudits} />
        </div>
      )}
    </>
  );
};
export default PoolAudit;
